<template>
  <header id="trek-header" qaid="nav-app" class="masthead" data-sticky-container>
    <div
      :id="isB2b ? 'js-sticky-header' : null"
      data-sticky
      data-sticky-on="small"
      data-options="marginTop:0;"
      data-top-anchor="1"
      style="width:100%"
    >
      <div id="search" class="exitStageTop">
        <slot name="search" />
      </div>
      <a id="preNav"></a>

      <!--  
        Phase 2: Unify the implementation for b2b and b2c
        Because b2b's header uses an inline-template, moving this markup into NavApp.vue
        requires a significant refactor. Let's save this for phase 2 when we address the functionality,
        html, css & etc. For now, I've used a slot.
      -->
      <template v-if="isB2b">
        <slot name="b2b" />
      </template>

      <section v-else class="header-wrap" :class="multiBrand ? 'header-wrap--multibrand' : null">
        <div id="abbreviatedNavigationBar">
          <div class="title-bar row" data-responsive-toggle="none" data-hide-for="large">
            <div class="title-bar__icon title-bar__icon-menu">
              <button
                class="hamburger-icon"
                type="button"
                data-toggle
                aria-label="<spring:theme code='menu.hamburger.toggle'/>"
                name="<spring:theme code='menu.hamburger.toggle'/>"
              ></button>
            </div>
            <div class="title-bar__logo">
              <slot name="logo" />
            </div>
            <div class="title-bar__icon title-bar__icon-search">
              <label class="js-site-search-icon">
                <a class="primary-navigation__primary-item__icon-link">
                  <i class="material-icons md-24">search</i>
                </a>
              </label>
            </div>
            <div v-if="canShowCart" class="title-bar__icon title-bar__icon-cart">
              <slot name="cart" />
            </div>
          </div>
        </div>
        <slot name="navigation" />
        <slot name="minicart" />
      </section>
    </div>
  </header>
</template>

<script>
export default {
  name: 'NavApp',
  props: {
    canShowCart: {
      type: Boolean,
      default: false,
    },
    isB2b: {
      type: Boolean,
      default: false,
    },
    multiBrand: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
